import React from 'react';
import _CopyRight from './_CopyRight.scss'

class CopyRight extends React.Component {

  render() {
    return (
      <div className='copyright-container'>
        <p className='footer-description'>Đơn vị chủ quản: SỞ CÔNG THƯƠNG TỈNH PHÚ YÊN</p>
        <p className='footer-description'>Địa chỉ: 78-80 Lê Duẩn, Tp.Tuy Hoà, tỉnh Phú Yên</p>
        <p className='footer-description'>Điện thoại: (0257).3841.907 - Fax: (0257).3841.585. Email: <a href="mailto:(socongthuong@sctphuyen.gov.vn)">socongthuong@sctphuyen.gov.vn</a></p>
      </div>
    );
  }
}
export default CopyRight;



// WEBPACK FOOTER //
// ./components/layouts/master/sub-footer/CopyRight.jsx